import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  CodeBlock,
  PagingSidePanelType,
  Box as Section,
  SidePanel,
  Tabs,
} from '@node-space/ui-components'
import type { CardTransaction } from 'services/CardService'
import { highlightRowBasedOnId } from 'utils/table/table'
import { sortObjectPropertiesByName } from 'utils/utils'
import { CardTransactionDetailsContent } from './CardTransactionDetailsContent'
import { CardTransactionDetailsHeader } from './CardTransactionDetailsHeader'

interface CardTransactionDetailsSidePanelProps {
  isOpen: boolean
  paging: PagingSidePanelType
  onClose: () => void
  transaction?: CardTransaction
}

export const CardTransactionDetailsSidePanel = ({
  isOpen,
  paging,
  onClose,
  transaction,
}: CardTransactionDetailsSidePanelProps) => {
  const { t } = useTranslation()

  if (!transaction) {
    return null
  }

  const payloadJsonString = JSON.stringify(sortObjectPropertiesByName(transaction), null, 3)

  return (
    <SidePanel
      id="side-panel-card-transaction-details"
      isOpen={isOpen}
      paging={paging}
      onClose={onClose}
      activeRowId={transaction.id}
      onActiveRowChange={highlightRowBasedOnId}
      header={<CardTransactionDetailsHeader transaction={transaction} />}
      body={
        <Section tag="section" width="full" background="layer-1">
          <Tabs
            tabs={[
              {
                id: 'details',
                header: t('customers.cardTransactionDetails.details'),
                content: <CardTransactionDetailsContent transaction={transaction} />,
              },
              {
                id: 'full-payload',
                header: t('customers.cardTransactionDetails.fullPayload'),
                content: (
                  <CodeBlock testId="raw-payload-view" code={payloadJsonString} language="json" />
                ),
              },
            ]}
          />
        </Section>
      }
    />
  )
}
